import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Dropdown } from "semantic-ui-react";
import { collegeProgramApi } from "@api/colleges/colleges"; // Adjust import path as needed

class CollegeDepartmentSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      loading: false,
      error: null,
    };
  }

  async componentDidMount() {
    await this.fetchColleges();
  }

  fetchColleges = async () => {
    this.setState({ loading: true, error: null });
    try {
      const response = await collegeProgramApi.listColleges();
      const colleges = response.data.data || [];

      // Transform API data to dropdown options format
      const options = colleges.map((college) => ({
        key: college.id,
        value: college.name, // Use the actual name from API
        text: college.name,
      }));

      this.setState({ options, loading: false });
    } catch (error) {
      console.error("Error fetching colleges:", error);
      this.setState({
        error: "Failed to load colleges",
        loading: false,
        // Fallback to default options if API fails
        options: [
          {
            key: "tech",
            value: "College of Technology",
            text: "College of Technology",
          },
          {
            key: "comp",
            value:
              "College of Computing, Multimedia Arts and Digital Innovation",
            text: "College of Computing, Multimedia Arts and Digital Innovation",
          },
          {
            key: "edu",
            value: "College of Education",
            text: "College of Education",
          },
          {
            key: "eng",
            value: "College of Engineering",
            text: "College of Engineering",
          },
          {
            key: "arts",
            value: "College of Arts and Sciences",
            text: "College of Arts and Sciences",
          },
          {
            key: "bus",
            value: "College of Business and Accountancy",
            text: "College of Business and Accountancy",
          },
        ],
      });
    }
  };

  // Helper method to ensure user's current college is in options
  getEnhancedOptions = () => {
    const { value } = this.props;
    const { options } = this.state;

    if (!value) return options;

    // Check if current value exists in options
    const existingOption = options.find((opt) => opt.value === value);

    if (!existingOption && value) {
      // Add user's current college to options if not found
      return [
        ...options,
        {
          key: `current-${value}`,
          value: value,
          text: value,
        },
      ];
    }

    return options;
  };

  render() {
    const { value, onChange, required, placeholder, label, name, disabled } =
      this.props;

    const { loading, error } = this.state;
    const dropdownOptions = this.getEnhancedOptions();

    return (
      <Form.Field required={required}>
        {label && <label>{label}</label>}
        <Dropdown
          placeholder={placeholder}
          fluid
          selection
          search
          name={name}
          value={value}
          options={dropdownOptions}
          onChange={onChange}
          disabled={disabled || loading}
          loading={loading}
          error={!!error}
          className="college-department-selector"
          allowAdditions // Allow adding new values
          additionLabel="Add college: "
        />
        {error && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
            {error}
          </div>
        )}
      </Form.Field>
    );
  }
}

CollegeDepartmentSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

CollegeDepartmentSelector.defaultProps = {
  value: "",
  required: false,
  placeholder: "Select College/Department",
  label: "College/Department",
  disabled: false,
};

export default CollegeDepartmentSelector;
